export enum DurationType {
    FLEXIBLE = 'FLEXIBLE',
    UNTIL = 'UNTIL',
    FROM = 'FROM',
    FIXED = 'FIXED',
    UNKNOWN = 'UNKNOWN',
}
